// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auxiliaryResources{margin-top:1.04167vw}.auxiliaryResources .operation{font-size:.83333vw;display:flex;align-items:center}.auxiliaryResources .operation span{display:inline-block;margin-left:.52083vw}.auxiliaryResources img{margin:0 .78125vw;cursor:pointer;width:1.14583vw;height:1.14583vw}", ""]);
// Exports
module.exports = exports;
